import {
  forwardRef,
  useContext,
  useImperativeHandle,
  useState,
  useRef,
} from 'react';

import { useParams } from 'react-router-dom';

import Input from '~/components/Material/Input';
import ModalDeleteContext from '~/components/ModalDelete/ModalContext';
import SideForm from '~/components/SideForm';
import DangerZone from '~/components/SideForm/DangerZone';
import FixedControl from '~/components/SideForm/FixedControl';
import Section from '~/components/SideForm/Section';
import Title from '~/components/SideForm/Title';
import api from '~/services/api';
import yupValidate from '~/utils/yupValidate';
import { createSchema, updateSchema } from '~/validators/pensionType.schemas';

import { Content } from './styles';

const Form = ({ ...rest }, ref) => {
  const { id } = useParams();

  const { openModalDelete } = useContext(ModalDeleteContext);

  const formRef = useRef();
  const [pensionType, setPensionType] = useState({});

  useImperativeHandle(
    ref,
    () => ({
      setData: (value) => setPensionType(value),
    }),
    []
  );

  const closeForm = (reload) => {
    setPensionType({});
    formRef.current.reset();
    rest.onClose(reload);
  };

  const storeTypePension = async (data) => {
    try {
      // Dados básicos
      const response = await api.post(
        `/lodgings/${id}/pension-types/${pensionType.id}`,
        data
      );

      if (response.status === 201) {
        closeForm(true);
      }
      return 'response';
    } catch (error) {
      if (error.response) {
        const { status } = error.response;

        if (status === 400) {
          return error;
        }
      }

      return error;
    }
  };

  const updateTypePension = async (data) => {
    try {
      // Dados básicos
      const response = await api.put(
        `/lodgings/${id}/pension-types/${pensionType.id}`,
        data
      );

      if (response.status === 200) {
        closeForm(true);
      }
      return 'response';
    } catch (error) {
      if (error.response) {
        const { status } = error.response;

        if (status === 400) {
          return error;
        }
      }
      return error;
    }
  };

  const handleSubmit = async (formData) => {
    // Limpa os erros
    formRef.current.setErrors({});

    const validationSchema = pensionType.id ? updateSchema : createSchema;
    // Valida os campos
    const { success, data, errors } = await yupValidate(validationSchema, {
      ...formData,
    });

    if (!success) {
      return formRef.current.setErrors(errors);
    }

    if (pensionType.id) {
      return updateTypePension(data);
    }

    return storeTypePension(data);
  };

  const handleOnClose = () => closeForm(false);

  const handleDelete = () => {
    openModalDelete({
      url: `/lodgings/${id}/pension-types/${pensionType.id}`,
      title: 'Deseja deletar o tipo pensão?',
      onDelete: () => closeForm(true),
      autoClose: true,
      messages: {
        success: 'Sucesso ao deletar o tipo pensão!',
        error: 'Erro ao deletar o tipo pensão...',
      },
    });
  };

  return (
    <SideForm
      formRef={formRef}
      data={pensionType}
      onClose={handleOnClose}
      onSubmit={handleSubmit}
    >
      <Content>
        <Title
          label={
            pensionType.id
              ? `Editando tipo pensão - ${pensionType.id}`
              : 'Novo tipo pensão'
          }
        />
        <Section>
          <Input label="Nome" name="description" />
          <Input
            label="Taxa CHD"
            name="price_chd"
            mask="currency"
            returnUnmasked
          />
        </Section>
        {pensionType.id && (
          <DangerZone message="Deletar tipo pensão" onClick={handleDelete} />
        )}
        <FixedControl />
      </Content>
    </SideForm>
  );
};

export default forwardRef(Form);
